import * as React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { platformFonts, usePlatformColors } from "../tickitPlatformTheme";

export default function PlatformLoadingBlock({ label = "Loading…", minHeight = 240, sx = {} }) {
  const colors = usePlatformColors();
  return (
    <Box
      role="status"
      aria-live="polite"
      aria-busy="true"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight,
        py: 4,
        ...sx,
      }}
    >
      <CircularProgress sx={{ color: colors.brand, mb: label ? 1.5 : 0 }} />
      {label && (
        <Typography sx={{ fontFamily: platformFonts.body, fontSize: "13.5px", color: "var(--platform-text-3)" }}>
          {label}
        </Typography>
      )}
    </Box>
  );
}
